import { Component, OnInit } 					                  from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators}      from '@angular/forms';
import {ErrorStateMatcher}                                        from '@angular/material/core';

import { Router, ActivatedRoute }                                 from '@angular/router';
import { first }                                                  from 'rxjs/operators';
import { NgxSpinnerService }                                      from 'ngx-spinner';

import { AlertService, OtpService, AuthenticationService }        from '../_services';
import { Globals  }                                               from '../_helpers';


export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
	    const isSubmitted = form && form.submitted;
	    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
	}
}

@Component({
  selector: 'assessor-otp',
  templateUrl: './otp.component.html',
})

export class OtpComponent {
	otponeFormControl = new FormControl('', [
	    Validators.required,
	]);
	otptwoFormControl = new FormControl('', [
	    Validators.required,
	]);
	otpthreeFormControl = new FormControl('', [
	    Validators.required,
	]);
	otpfourFormControl = new FormControl('', [
	    Validators.required,
	]);
  	matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg : string;
    returnUrl: string;
    userData = {};
    settings = {};
    successMsg: string = '';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private otpService: OtpService,
        private alertService: AlertService,
        private authenticationService: AuthenticationService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {}


    ngOnInit() {
        var step = this.route.snapshot.paramMap.get("step");
        if(step != this.globals.complSteps['otp'])
            //this.router.navigateByUrl('/login');

    	this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
        if(this.userData['usercode'] === undefined)
        {
            var params = window.atob(step);
            var splitStr = params.split('//@spwd++sup@//');
            this.userData['usercode'] = splitStr[0];
            this.userData['userid'] = splitStr[1];
            this.userData['subuserid'] = splitStr[2];
            this.userData['id'] = splitStr[3];            
            }        
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';
    }

    public otpSubmit() {
        this.successMsg = '';
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.otponeFormControl.value == '' || this.otptwoFormControl.value == '' || this.otpthreeFormControl.value == '' || this.otpfourFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else{ 
            var otp = this.otponeFormControl.value+''+this.otptwoFormControl.value+''+this.otpthreeFormControl.value+''+this.otpfourFormControl.value;

            this.loading = true;
            this.spinner.show();
            this.otpService.otpverify(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], otp, this.settings['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    if(data.code == 1000){
                        this.isErrorLogin = false;
                        this.authStage();
                        var parms = this.globals.getRandUrl('verify');
                        this.router.navigateByUrl('/verify/'+parms);
                    }
                    else if(data.status == 1001){
                        this.loading = false;
                        this.isErrorLogin = false;
                        this.router.navigateByUrl('/login');
                    }
                    else{
                        this.isErrorLogin = true;
                        this.errorMsg = 'Otp Expire !!';
                        this.loading = false;
                    }
                    this.spinner.hide();
                },
                error => {
                    this.isErrorLogin = true;
                    this.errorMsg = 'Otp Expire !!';
                    this.alertService.error(error);
                    this.loading = false;
                    this.spinner.hide();
                }
            );
        }
    }

    public resendOtp(){
        this.successMsg = '';
        this.spinner.show();
        this.otpService.resendOpt(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    this.isErrorLogin = false;
                    this.successMsg = "OTP has been sent on your registered mobile."
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.isErrorLogin = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.isErrorLogin = true;
                    this.errorMsg = 'Otp Expire !!';
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.isErrorLogin = true;
                this.errorMsg = 'Otp Expire !!';
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public keytab(event, index){
	    var textBox = document.getElementById("otp-"+index);
        textBox.focus();
	}
    public authStage(){
        this.authenticationService.authStage(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], 1)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    console.log('Auth Stage 1 updated');
                }
            }
        );
    }    
}
